<template>
  <div class="row">
    <div class="col-lg-6 m-auto">
      <v-img
        max-height="220"
        max-width="400"
        contain
        class="mx-auto mb-4"
        :src="logo"
      />
      <card :title="$t('reset_password')">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="send"
        >
          <v-col cols="12">
            <v-text-field
              v-model="form.email"
              :rules="[rules.required, rules.emailFormat]"
              label="Correo Electrónico"
              placeholder="ejemplo@dominio.com"
              :color="bgColor"
              required
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              :disabled="!valid || form.busy"
              class="mr-4 white--text"
              :loading="form.busy"
              :color="bgColor"
              block
              @click="validate"
            >
              {{ $t('send_password_reset_link') }}
            </v-btn>
          </v-col>
        </v-form>
      </card>
    </div>
  </div>
</template>

<script>
import Form from 'vform';

export default {
  middleware: 'guest',
  layout: 'auth',

  metaInfo() {
    return { title: this.$t('reset_password') };
  },

  data: () => ({
    form: new Form({
      email: '',
      type: 'D',
    }),
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
    },
    valid: false,
    apiURL: '/api/password/email',
    method: 'POST',
    logo: '/img/logo_hka.png',
  }),

  computed: {
    isEbipac() {
      const env = process.env.VUE_APP_ENV;
      return env === 'EBI' || env === 'ebipac';
    },
    bgColor() {
      return this.isEbipac ? '#0A3D91' : '#0084CA';
    },
  },

  mounted() {
    const url = window.location;
    if (this.isEbipac || url.href.includes('ebi-pac')) {
      this.logo = '/img/ebi-pac.png';
    }
  },

  methods: {
    async send() {
      this.form.busy = true;

      window.axios({
        method: this.method,
        url: this.apiURL,
        data: this.form,
      }).then((result) => {
        this.$store.dispatch('notifications/show', {
          message: result.data.status,
          type: 'success',
        });
        if (result.data.status !== 'El correo no se encuentra en nuestros registros.') {
          this.$router.push({ name: 'login', params: { action: 'logout', message: result.data.status } });
        }
        this.form.busy = false;
      }).catch(() => {
        this.form.busy = false;
      });
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.send();
      }
    },
  },
};
</script>
